import { render, staticRenderFns } from "./brandCategoryBlack.vue?vue&type=template&id=38714480&scoped=true"
import script from "./brandCategoryBlack.vue?vue&type=script&lang=js"
export * from "./brandCategoryBlack.vue?vue&type=script&lang=js"
import style0 from "./brandCategoryBlack.vue?vue&type=style&index=0&id=38714480&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38714480",
  null
  
)

export default component.exports